import React from 'react';
import { motion } from 'framer-motion';
import type { SlideProps } from './SlideShell';
export function SlideAgencyOfRecord({}: SlideProps) {
  return <div className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-[var(--brand)] px-[clamp(2rem,6vw,6rem)] text-center" data-id="element-136" data-mp="2vbrvn6dmd357">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full border-[40px] border-white/10" data-id="element-137" data-mp="2lkx9s34ac5ka" />
      <div className="pointer-events-none absolute -bottom-28 -left-20 h-80 w-80 rounded-full border-[40px] border-white/10" data-id="element-138" data-mp="399zrtc2u00fb" />

      <motion.p initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="relative mb-6 text-[clamp(0.75rem,1vw,0.95rem)] font-bold uppercase tracking-[0.3em] text-white/65" data-id="element-139" data-mp="3e66tgso72prg">
        Snakker
      </motion.p>

      <motion.h1 initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.15,
      duration: 0.7,
      ease: 'easeOut'
    }} className="relative max-w-6xl text-[clamp(3rem,8vw,8.5rem)] font-extrabold uppercase leading-[0.95] tracking-[-0.045em] text-white" data-id="element-140" data-mp="1nygcgxvjxryj">
        Snak agency
        <br data-id="element-141" data-mp="kob0svv7anuw" />
        of record
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.55,
      duration: 0.55
    }} className="relative mt-8 text-[clamp(1.25rem,2.3vw,2.15rem)] font-bold leading-tight text-white" data-id="element-142" data-mp="kloraqor1ya1">
        Not just making campaigns. Running them.
      </motion.p>
      <motion.p initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.7,
      duration: 0.5
    }} className="relative mt-3 text-[clamp(0.85rem,1.3vw,1.15rem)] font-semibold tracking-[0.08em] text-white/70" data-id="element-143" data-mp="13e9ebrhrp95x">
        Across brands. Across countries. Across time.
      </motion.p>
    </div>;
}